import { MdOpenInFull } from 'react-icons/md';
import styles from './headered-container.module.scss';

interface Props {
    title: string;
    showExpand?: boolean;
    onShowExpandClick?: () => void;
    canCollapse?: boolean;
    defaultCollaped?: boolean;
    customRightComponent?: JSX.Element;
    className?: string;
    card?: boolean;
    // stickyTopPixels?: number;
    children: any;
}

export default function HeaderedContainer(props: Props) {
    let style: { [key: string]: any } = {}

    const classes = [
        styles.list,
        props.card ? styles.list_card : undefined,
        props.className,
    ].filter(Boolean).join(' ');

    return (
        <div className={classes} key={props.title}>
            <div className={styles.list_header} style={style}>
                <h6>{props.title}</h6>
                { props.showExpand && (
                    <div onClick={props.onShowExpandClick} className={styles.expand_button}>
                        <MdOpenInFull></MdOpenInFull>
                    </div>
                )}
                { props.canCollapse && (
                    <div className={styles.collapse_button}>
                        <MdOpenInFull></MdOpenInFull>
                    </div>
                )}
                {
                    props.customRightComponent && props.customRightComponent
                }
            </div>

            {props.children}
        </div>
    )
}
